import NetworkUtil from "./NetworkUtil";
import { SpecimenSource } from "../types/SpecimenSource";
import {ServerResponse} from "../types/ServerResponse";

export default class SpecimenSourceAPI {

    public static async getAllSpecimenSourceData():Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makeGet("/api/admin/specimenSource");
    }

    public static async getEnabledSpecimenSourceData():Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makeGet("/api/admin/specimenSource/enabled");
    }

    public static async filterSpecimenSources(filter:{filter:{Description?,SpecimenSource?,Test?, IsEnabled?, StarlimsName?}}):Promise<{success:boolean, reason:string, data}>{
        return NetworkUtil.makePost("/api/admin/specimenSource/filter", filter)
    }

    public static async createSpecimenSource(specimenSource:SpecimenSource):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/specimenSource/create", specimenSource)
    }
    
    public static async editSpecimenSource(specimenSource):Promise<ServerResponse>{
        return NetworkUtil.makePost("/api/admin/specimenSource/edit", specimenSource)
    }

}